import { useState, useEffect } from "react";
import useAuth from "./useAuth";
import { IOD_BASE_URL } from "../config";
import API from "../API";

const initialState = {
  ioditems: [],
  page: 0,
  total_pages: 0,
  total_results: 0,
};

export const useInjuriesListFetch = () => {
  const auth = useAuth();
  const [state, setState] = useState(initialState);
  const [searchValue, setSearchValue] = useState("");
  const [includeInactive, setIncludeInactive] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true); // ✅ Prevent double fetching

  const accessToken = auth.auth.accessToken;

  const fetchInjuriesList = async (page, searchValue, reset = false) => {
    if (!hasMore && !reset) return; // Stop fetching if no more pages

    try {
      setLoading(true);
      setError(false);

      console.log(reset)

      const data = await API.fetchInjuries(searchValue, page, includeInactive, "", accessToken);
      console.log(data.ioditems)
      

      setState((prev) => ({
        ...prev,
        ioditems: reset ? data.ioditems : [...prev.ioditems, ...data.ioditems], // ✅ Only reset on filter/search change
        page: page + 1,
        total_pages: data.total_pages,
        total_results: data.total_results,
      }));

      setHasMore(data.ioditems.length > 0);
      setLoading(false);
      setTrigger(false)
    } catch (error) {
      console.error("Error fetching stock items:", error);
      setError(true);
    }
  };

  useEffect(() => {
    if (firstLoad) {
      setFirstLoad(false);
      fetchInjuriesList(1, searchValue, true);
    }
  }, [firstLoad]); // ✅ Runs only once when the component mounts

  useEffect(() => {
    fetchInjuriesList(1, searchValue, true); // ✅ Fetch when search/filter changes
  }, [searchValue,trigger, includeInactive]);

  return { state, loading, error,searchValue, setSearchValue, setIncludeInactive, fetchInjuriesList,setTrigger };
};
